import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ProSidebarProvider } from "react-pro-sidebar";
import { store } from "./redux/store";
import App from "./App";
import "react-quill/dist/quill.snow.css";
import 'react-quill/dist/quill.core.css'
import 'react-quill/dist/quill.bubble.css'



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
        <ProSidebarProvider>
          <App />
        </ProSidebarProvider>
    </Provider>
  </>
);
